import { render, staticRenderFns } from "./guardian-group.vue?vue&type=template&id=37547e62"
import script from "./guardian-group.ts?vue&type=script&lang=js&external"
export * from "./guardian-group.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports